import React from "react";
import Shirt from "./Shirt";

interface IProps {
  elementType?: number;
  sizes: string;
}

const PlaceholderShirt: React.FC<IProps> = ({ elementType, sizes }) => {
  const suffix = elementType === 1 ? `_${elementType}` : "";
  return (
    <Shirt path={`/dist/img/shirts/standard/shirt_0${suffix}`} sizes={sizes} />
  );
};

export default PlaceholderShirt;
